import React from 'react';
import { sizes } from '@sharefiledev/antd-config';
import { Button, Flex } from 'antd';

export interface ModalFooterProps {
	primaryDisabled?: boolean;
	defaultDisabled?: boolean;
	primaryText: string;
	defaultText: string;
	onPrimaryButtonClick: () => void;
	onDefaultButtonClick: () => void;
}

export const ModalFooter: React.FC<ModalFooterProps> = ({
	primaryDisabled,
	defaultDisabled,
	primaryText,
	defaultText,
	onPrimaryButtonClick,
	onDefaultButtonClick,
}) => {
	return (
		<Flex
			justify="space-between"
			role="group"
			style={{
				marginTop: sizes.MD,
			}}
		>
			<Button type="primary" onClick={onPrimaryButtonClick} disabled={primaryDisabled}>
				{primaryText}
			</Button>
			<Button type="default" onClick={onDefaultButtonClick} disabled={defaultDisabled}>
				{defaultText}
			</Button>
		</Flex>
	);
};
